import { FieldRenderProps } from 'react-final-form'
import CheckboxForm from '../../control/CheckboxForm'

type SelectInputProps = FieldRenderProps<any>

const CheckboxGroupInput: React.FC<SelectInputProps> = ({ input, meta, checked, ...rest }) => {
    return <CheckboxForm {...input} {...rest} meta={meta} helperText={meta.error} />
}

export default CheckboxGroupInput
